import AjaxService, { validateResponse } from '../services/ajax-service';

import { handleServerError } from 'shared-services/error-service';

export const fetchApps = ({ offset, limit }) => {
    return AjaxService({
        method: 'get',
        url: 'apps',
        params: {
            offset,
            limit
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const createApp = ({ name, description, scopes, redirect_urls }) => {
    return AjaxService({
        method: 'post',
        url: 'apps',
        data: {
            name,
            description,
            scopes,
            redirect_urls
        }
    })
    .then(response => response.data?.app)
    .catch(handleServerError);
}

export const fetchApp = (appId, token) => {
    return AjaxService({
        method: 'get',
        url: `apps/${appId}`
    }, undefined, token)
    .then(response => validateResponse(response, 'id').data)
    .catch(handleServerError);
}

export const updateApp = (appId, { name, description, scopes, redirect_urls }) => {
    return AjaxService({
        method: 'put',
        url: `apps/${appId}`,
        data: {
            name,
            description,
            scopes,
            redirect_urls
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeApp = appId => {
    return AjaxService({
        method: 'delete',
        url: `apps/${appId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const authorize = (appId, token) => {
    return AjaxService({
        method: 'put',
        url: `apps/authenticate/${appId}`
    }, false, token)
    .then(response => response.data)
    .catch(handleServerError);
}

export const createWebhook = (appId, endpoint, event) => {
    return AjaxService({
        method: 'post',
        url: 'api/webhooks',
        data: {
            app_id: appId,
            endpoint,
            event
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const updateWebhook = (id, props) => {
    return AjaxService({
        method: 'put',
        url: `api/webhooks/${id}`,
        data: props
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeWebhook = (id, appId) => {
    return AjaxService({
        method: 'delete',
        url: `api/webhooks/${id}`,
        data: {
            app_id: appId
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const fetchWebhooks = ({ appId, offset, limit }) => {
    return AjaxService({
        method: 'get',
        url: `api/webhooks/${appId}`,
        params: {
            offset,
            limit
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}
